import React, { useEffect, useState } from 'react';
import { getFactories, createFactory, updateFactory } from '../services/api';
import toast from 'react-hot-toast';

const emptyForm = { name: '', address: '' };

export default function Factories() {
  const [factories, setFactories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editFactory, setEditFactory] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    getFactories()
      .then(res => setFactories(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openCreate = () => { setEditFactory(null); setForm(emptyForm); setShowModal(true); };
  const openEdit = (f) => { setEditFactory(f); setForm({ name: f.name, address: f.address || '' }); setShowModal(true); };

  const handleSave = async () => {
    if (!form.name) return toast.error('Το όνομα είναι υποχρεωτικό');
    setSaving(true);
    try {
      if (editFactory) {
        await updateFactory(editFactory.id, form);
        toast.success('Το εργοστάσιο ενημερώθηκε');
      } else {
        await createFactory(form);
        toast.success('Το εργοστάσιο δημιουργήθηκε');
      }
      setShowModal(false);
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Σφάλμα');
    } finally {
      setSaving(false);
    }
  };

  const handleToggle = async (f) => {
    try {
      await updateFactory(f.id, { is_active: !f.is_active });
      toast.success(f.is_active ? 'Απενεργοποιήθηκε' : 'Ενεργοποιήθηκε');
      load();
    } catch { toast.error('Σφάλμα'); }
  };

  return (
    <>
      <div className="page-header">
        <div className="flex-between">
          <div>
            <h2>Εργοστάσια</h2>
            <p>Διαχείριση εγκαταστάσεων παραγωγής</p>
          </div>
          <button className="btn btn-primary" onClick={openCreate}>+ Νέο Εργοστάσιο</button>
        </div>
      </div>
      <div className="page-body">
        {loading ? (
          <div className="page-loading"><span className="loading-spinner dark" /></div>
        ) : (
          <div className="grid-2">
            {factories.map(f => (
              <div key={f.id} className="card">
                <div className="card-body">
                  <div className="flex-between" style={{ marginBottom: 12 }}>
                    <div>
                      <div style={{ fontSize: 17, fontWeight: 700, fontFamily: 'var(--font-display)' }}>{f.name}</div>
                      {f.address && <div style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 3 }}>📍 {f.address}</div>}
                    </div>
                    <span className={`badge ${f.is_active ? 'badge-green' : 'badge-gray'}`}>
                      {f.is_active ? 'Ενεργό' : 'Ανενεργό'}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--gray-400)', marginBottom: 16 }}>
                    ID: {f.id} · Δημιουργήθηκε: {new Date(f.created_at).toLocaleDateString('el-GR')}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="btn btn-secondary btn-sm" onClick={() => openEdit(f)}>✏️ Επεξεργασία</button>
                    <button className={`btn btn-sm ${f.is_active ? 'btn-danger' : 'btn-success'}`} onClick={() => handleToggle(f)}>
                      {f.is_active ? 'Απενεργοποίηση' : 'Ενεργοποίηση'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editFactory ? 'Επεξεργασία Εργοστασίου' : 'Νέο Εργοστάσιο'}</span>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Όνομα Εργοστασίου *</label>
                <input className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="π.χ. Αρτοποιείο Κεντρικό" />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Διεύθυνση</label>
                <input className="form-input" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="π.χ. Αθήνα, Οδός 123" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Ακύρωση</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                {saving ? <span className="loading-spinner" /> : (editFactory ? 'Αποθήκευση' : 'Δημιουργία')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
